export const environment = {
    NODE_ENV: null,
    GA_ID: null,
    production: true,
    configFile: 'assets/config/config.json',
    appVersion: '',
    FIREBASE_CONFIG: {
        apiKey: "AIzaSyCFd4n0IF77a1eJ23LYHoGp4bC2SU-jpf8",
        authDomain: "lovely-fashion-ck.firebaseapp.com",
        projectId: "lovely-fashion-ck",
        storageBucket: "lovely-fashion-ck.firebasestorage.app",
        messagingSenderId: "309096948328",
        appId: "1:309096948328:web:58823f54977c955f87d1dd",
        measurementId: "G-EWPJH2B2LH"
    },
  };
